<div [ngClass]="{'px-0':isTalentInsightsModule}">
  <div class="wccard p-3 gray-border">
    <div class="mb-3">
      <div class="">

        <div class="row mb-4">
          <div class="col">
            <div class="d-flex justify-content-between mb-3">
            <span class="f-14 font-weight-500"> Upload a JD </span>
            <span class="f-14 font-weight-600 pointer" *ngIf="!isTalentInsightsModule" (click)="modalService.dismissAll()">
              <span><i class=" fa-solid fa-times"></i></span>
            </span>
            </div>
            <div class="ats-upload-btn d-flex justify-content-center align-items-center">
              <div *ngIf="!isUploadedFileCorrect" class="col text-center p-5">
                <div class="col">
                  <p class="font-weight-600 text-bluex mb-0">
                    Drag and drop JD file here
                  </p>
                </div>
              </div>

              <input data-testid="auto-app-jd-search-input-1" *ngIf="!isUploadedFileCorrect" type="file" #document (change)="uploadFile($event)"
                accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">
              <div class="text-center d-flex p-6" *ngIf="isUploadedFileCorrect">
                <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
                {{ uploadedFilename }}
                <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" (click)="resetFormFields()">Remove
                </p>
              </div>

            </div>
          </div>
        </div>

        <div *ngIf="!enteredJobDescription || enteredJobDescription.length == 0" class="align-items-center">
          <p *ngIf="isUploadedFileCorrect && !specialCharaterError && !incorrectFileFormat"
            [ngClass]="['text-left','my-1']">
            <span class="font-weight-600">Uploaded file:</span> {{ uploadedFilename }}
          </p>
          <p *ngIf="textExtractionError" class="f-12 text-danger font-weight-500 my-2">Error while extracting text. {{
            textExtractionErrorMessage }}</p>
          <p *ngIf="specialCharaterError" [ngClass]="['text-left','my-1','text-danger']">
            Filename should not contain any special characters
          </p>
          <p *ngIf="incorrectFileFormat" [ngClass]="['text-left','my-1','text-danger']">
            File type should be .doc or .pdf or .docx or .txt
          </p>
          <p *ngIf="fileSizeLimitExceeded" [ngClass]="['text-left','my-1','text-danger']">
            File size cannot exceed 5 MB
          </p>
        </div>

        <!-- <div class="position-relative">
              <h5 class="center-position f-16" *ngIf="!enteredJobDescription || enteredJobDescription.length == 0"> OR </h5>
              <hr>
            </div> -->
        <div class="position-relative">
          <div class="horizontal-line" *ngIf="!enteredJobDescription || enteredJobDescription.length == 0"></div>
          <span class="or" *ngIf="!enteredJobDescription || enteredJobDescription.length == 0">OR</span>
        </div>
        <div class="row">
          <div class="col">
            <p class="mb-2 f-14 font-weight-500">
              Paste Job Description
            </p>
            <div class="position-relative ">
              <textarea data-testid="auto-app-jd-search-textarea-1" type="text" placeholder="Enter the job description" [(ngModel)]="enteredJobDescription"
                class="wc-textarea wc-form-control" rows="4"></textarea>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="modal-footer b pt-0 pr-0 pb-0">
      <button data-testid="auto-app-jd-search-button-1" [disabled]="isDescriptionEmpty" *ngIf="!isTalentInsightsModule" class="btn-trms-medium m-0"
        [ngStyle]="{'opacity': isDescriptionEmpty ? '0.65' : '1'}" (click)="addJobDescription()">
        <span *ngIf="!isTalentInsightsModule" [ngClass]="{ 'spinner-border text-light': jdDataLoading }"
          [ngStyle]="{ 'width: 20px; height: 20px;': jdDataLoading }">
          {{jdDataLoading ? '' : 'Save & Next'}}
        </span>
      </button>
      <button data-testid="auto-app-jd-search-button-2" class="btn-trms-medium d-block" *ngIf="isTalentInsightsModule" [disabled]="isDescriptionEmpty"
        [ngClass]="{ 'disabled-button': isDescriptionEmpty }" (click)="addJobDescription()">
        <i class="fa-regular fa-file-chart-pie"></i> Build Report
      </button>
    </div>
  </div>
</div>
